function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-265.74 -178.707)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M279.5,178.707H267.005c-1.031,0-1.254.223-1.254,1.256l0,4.207c0,3.7.006,7.393-.014,11.09a2.521,2.521,0,0,0,1.627,2.679l13.2.018,0-.166c.005-.126.01-.149.014-.239.013-.325,0-.436,0-.686q.028-8.538.013-17.076C280.594,178.981,280.317,178.707,279.5,178.707Zm-11.511,16.628c.039,0,.077,0,.116,0h10.763v.9h-.714q-5.091,0-10.181,0a.54.54,0,0,1-.392-.138.419.419,0,0,1-.114-.3C267.464,195.532,267.664,195.355,267.986,195.335Zm-.5-1.7v-13.18h11.383v13.18Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.284,181.592q-3.249-.006-6.5,0c-.782,0-1.1.32-1.1,1.1q-.006,1.752,0,3.508c0,.8.322,1.112,1.137,1.114q1.141,0,2.278,0h2.846q.665,0,1.329,0c.81,0,1.125-.318,1.129-1.124q0-1.731,0-3.461C277.4,181.911,277.086,181.592,276.284,181.592Zm-.632,1.739v2.238h-5.227v-2.238Z",
  transform: "translate(0.132 0.13)"
}));

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1899ae",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.856,
    height: 19.25,
    viewBox: "0 0 14.856 19.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.29794877051e7f3f272abbdebe58b74d.svg";
export { ForwardRef as ReactComponent };